'use strict';

const {ROLES_TO_PERMISSIONS} = require('../constants');

/**
 * @param {string[]} roles
 * @return {string[]}
 */
exports.getPermissions = (...roles) => {
    const permissions = [];
    for (const role of roles) {
        if (ROLES_TO_PERMISSIONS[role]) {
            permissions.push(...ROLES_TO_PERMISSIONS[role]);
        }
    }
    return [...new Set(permissions)];
};
